
























































import Vue from "vue";
import Modal from "@/components/Modal/Modal.vue";
import { store } from "@/store/store";
import Utils from "@/utils/utils";
import { ApiResponse, FormType, UserRole } from "@/types/types";
import { Agence } from "@/store/modules/Agence/interface";
import { Role } from "@/store/modules/Role/interface";
import { Response_ } from "@/plugins/axios/response";
export default Vue.extend({
  name: "UserModalCreate",
  components: { Modal },
  props: {
    poste_id: {
      type: String,
      default: undefined
    },
    should_display: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => undefined
    },
    onValidate: {
      type: Function,
      default: () => undefined
    },
    user: {
      type: Object
    },
    onAction: {
      type: Function,
      default: () => undefined
    }
  },
  data() {
    return {
      form: this.$props.user ? this.$props.user : { mail: "", agence: "", role: "" },
      loading: false
    };
  },
  methods: {
    displayTitle(): string {
      return this.$props.user ? "Modifier l'utilisateur" : "Créer un utilisateur";
    },
    displayButtonContent(): string {
      return this.$props.user ? "Modifier" : "Créer";
    },
    onInputChange(value: string, type: string): void {
      this.form[type] = value || "";
    },
    async validate(): Promise<void> {
      this.loading = true;
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        const request_result = await this.onValidate(
          this.$props.user ? FormType.UPDATE : FormType.CREATE,
          { mail: this.form.mail, agence: this.form.agence, role: this.form.role },
          this.$props?.user?._id
        );
        if (
          (request_result as Response_).status === ApiResponse.CREATED ||
          (request_result as Response_).status === ApiResponse.SUCCESS
        ) {
          this.onAction({
            type: "SUCCESS",
            title: "Utilisateur Créer",
            content: (request_result as Response_).message
          });
          this.loading = false;
          this.onClose();
          return;
        } else {
          this.onAction({
            type: "ERROR",
            title: "Erreur",
            content: (request_result as Response_).message
          });
        }
      }
      this.loading = false;
    }
  },
  computed: {
    emailRules(): Array<(value: string) => boolean | string> {
      return [
        (value: string): boolean | string => value.length > 0 || `Le champ email est obligatoire.`,
        (value: string): boolean | string => Utils.validateEmail(value) || `L'email n'a pas la bonne syntaxe.`
      ];
    },
    agenceRules(): Array<(value: string) => boolean | string> {
      return [
        (value: string): boolean | string => value.length > 0 || `Le champ agence est obligatoire.`,
        (value: string): boolean | string =>
          this.agences.find((agence) => agence._id === value) === undefined
            ? `La valeur renseignée n'est pas valide`
            : true
      ];
    },
    roleRules(): Array<(value: string) => boolean | string> {
      return [
        (value: string): boolean | string => value.length > 0 || `Le champ role est obligatoire.`,
        (value: string): boolean | string =>
          this.roles.find((role) => role._id === value) === undefined ? `La valeur renseignée n'est pas valide` : true
      ];
    },
    agences(): Array<Agence> {
      const logged_user = store.getters.LOGGED_USER;
      const agences = store.getters.AGENCE_ALL_ID.map((agence) => store.getters.AGENCE_BY_ID[agence]);
      return store.getters.ROLE_BY_ID[logged_user?.role as string].name.toUpperCase() === UserRole.ADMINISTRATOR
        ? agences.filter((agence) => agence.name === "Paris" || agence.name === "Lyon")
        : [store.getters.AGENCE_BY_ID[logged_user?.agence as string]];
    },
    roles(): Array<Role> {
      const logged_user = store.getters.LOGGED_USER;
      let roles = store.getters.ROLE_ALL_ID.map((role) => store.getters.ROLE_BY_ID[role]);
      if (store.getters.ROLE_BY_ID[logged_user?.role as string].name.toUpperCase() !== UserRole.ADMINISTRATOR)
        roles = roles.filter((role) => role.name.toUpperCase() !== UserRole.ADMINISTRATOR);
      return roles;
    }
  }
});
